class ACReveal extends HTMLElement {
  connectedCallback() {
    this.doors = this.querySelectorAll('.ac-door');
    this.prevBtn = this.querySelector('[data-page-prev]');
    this.nextBtn = this.querySelector('[data-page-next]');
    this.indicator = this.querySelector('[data-page-indicator]');
    this.grid = this.querySelector('[data-door-grid]');

    this.prevBtn.addEventListener('click', () => this.goToPage(this.currentPage - 1));
    this.nextBtn.addEventListener('click', () => this.goToPage(this.currentPage + 1));

    this.doors.forEach((door) => {
      door.addEventListener('click', () => this.openDoor(door));
    });

    this.currentPage = 1;
    this.render();

    this._onResize = () => {
      clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(() => this.render(), 150);
    };
    window.addEventListener('resize', this._onResize);
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this._onResize);
    clearTimeout(this._resizeTimer);
  }

  openDoor(door) {
    const isOpen = door.getAttribute('aria-expanded') === 'true';
    door.setAttribute('aria-expanded', String(!isOpen));
  }

  goToPage(page) {
    if (page < 1 || page > this.totalPages || this.isFading) return;
    this.isFading = true;
    this.grid.classList.add('is-fading');
    setTimeout(() => {
      this.currentPage = page;
      this.render();
      this.grid.classList.remove('is-fading');
      this.isFading = false;
    }, 300);
  }

  render() {
    const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
    const attr = isDesktop ? 'pageDesktop' : 'pageMobile';
    this.totalPages = isDesktop ? 2 : 5;

    if (this.currentPage > this.totalPages) this.currentPage = this.totalPages;

    this.doors.forEach((door) => {
      door.hidden = Number(door.dataset[attr]) !== this.currentPage;
    });
    this.indicator.textContent = `${this.currentPage} of ${this.totalPages}`;
    this.prevBtn.disabled = this.currentPage === 1;
    this.nextBtn.disabled = this.currentPage === this.totalPages;
  }
}

if (!customElements.get('ac-reveal')) {
  customElements.define('ac-reveal', ACReveal);
}
